var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-5 wizard-box-right wizard-box-progress",attrs:{"id":'wizard-step-'+this.id}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }